var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{class:['bundle', { 'bundle--3': _vm.ver === '3' }]},[(_vm.ver === '3' && _vm.title)?_c('legend',{staticClass:"bundle__title",domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e(),_c('ul',{class:[
			'list bundle__list',
			{
				'list--vertical': _vm.verticalUi,
			},
		]},_vm._l((_vm.radioList),function(item,idx){return _c('li',{key:idx,staticClass:"list__item bundle__list-item"},[_c('label',{class:[
					'radio-box bundle__label',
					{ 'bundle__label--checked': _vm.isChecked(item[_vm.keyName]) },
				]},[_c('input',{class:[
						'radio-box__input',
						_vm.inputClass,
						'bundle__input',
					],attrs:{"disabled":_vm.isDisabled(item[_vm.keyName]),"type":"radio"},domProps:{"value":item[_vm.keyName],"checked":_vm.isChecked(item[_vm.keyName])},on:{"change":function($event){return _vm.onChange(item[_vm.keyName], item[_vm.valueName])},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('enter')}}}),_c('span',{class:[
						'radio-box__text bundle__item-title',
						{
							'radio-box__text--checked': _vm.isChecked(
								item[_vm.keyName]
							),
							'radio-box__text--disabled': _vm.isDisabled(
								item[_vm.keyName]
							),
							large: _vm.size === 'lg',
						},
					]},[_vm._v(_vm._s(item[_vm.valueName]))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }